export const zones = [
    {
      id: 1,
      name: "Shattered Vestibule - Entry Hall",
      region: "Shattered Vestibule",
      level_range_min: 1,
      level_range_max: 3,
      effect: "none",
      effect_description: "Neutral conditions",
      description: "Crumbling entrance with marble statues and faded banners",
      enemy_types: ["Skeleton", "Bone Rat"],
      hazards: ["Crumbling floors", "Spiked traps"],
    },
    {
      id: 2,
      name: "Flooded Catacombs - Drowned Passage",
      region: "Flooded Catacombs",
      level_range_min: 6,
      level_range_max: 8,
      effect: "frost",
      effect_description: "Your attacks are weaker (-20% ATK)",
      description: "Submerged tunnels with glowing algae",
      enemy_types: ["Drowned Revenant", "Spectral Siren"],
      hazards: ["Deep water", "Slippery moss"],
    },
    {
      id: 3,
      name: "Cursed Expanse Wastes - Ashen Plains",
      region: "Cursed Expanse Wastes",
      level_range_min: 4,
      level_range_max: 7,
      effect: "blood",
      effect_description: "Enemies have +5 HP",
      description: "Barren wasteland with ash storms",
      enemy_types: ["Ash Vulture", "Veil Stalker"],
      hazards: ["Ash storms", "Cracked earth"],
    },
    {
      id: 4,
      name: "Shattered Vestibule - Guarded Crypts",
      region: "Shattered Vestibule",
      level_range_min: 4,
      level_range_max: 5,
      effect: "none",
      effect_description: "Neutral conditions",
      description: "Shallow tombs with sarcophagi and skeletal guards",
      enemy_types: ["Skeletal Archer", "Restless Shade"],
      hazards: ["Poison darts", "Collapsing walls"],
    },
    {
      id: 5,
      name: "Shattered Vestibule - Echoing Gallery",
      region: "Shattered Vestibule",
      level_range_min: 6,
      level_range_max: 7,
      effect: "none",
      effect_description: "Neutral conditions",
      description: "Mirrored hall with ghostly reflections, disorienting players",
      enemy_types: ["Mirror Phantom", "Echo Wraith"],
      hazards: ["Illusion traps", "Sound-based ambushes"],
    },
    {
      id: 6,
      name: "Shattered Vestibule - Royal Audience Chamber",
      region: "Shattered Vestibule",
      level_range_min: 8,
      level_range_max: 9,
      effect: "blood",
      effect_description: "Enemies have +5 HP",
      description: "Decayed throne room haunted by the King’s guards",
      enemy_types: ["Royal Skeleton", "Spectral Herald"],
      hazards: ["Throne-activated traps", "Falling chandeliers"],
    },
    {
      id: 7,
      name: "Flooded Catacombs - Tidal Tombs",
      region: "Flooded Catacombs",
      level_range_min: 9,
      level_range_max: 11,
      effect: "water",
      effect_description: "Movement speed reduced (-15%)",
      description: "Flooded burial chambers with ancient coffins",
      enemy_types: ["Waterlogged Ghoul", "Sea Wraith"],
      hazards: ["Flood currents", "Submerged spikes"],
    },
    {
      id: 8,
      name: "Sunken Library - Silent Archives",
      region: "Sunken Library",
      level_range_min: 10,
      level_range_max: 12,
      effect: "silence",
      effect_description: "Spells cost +10% mana",
      description: "Submerged library with floating books and eerie silence",
      enemy_types: ["Ink Phantom", "Tome Guardian"],
      hazards: ["Ink spills", "Collapsing shelves"],
    },
    {
      id: 9,
      name: "Abyssal Cistern - Frozen Depths",
      region: "Abyssal Cistern",
      level_range_min: 11,
      level_range_max: 13,
      effect: "frost",
      effect_description: "Your attacks are weaker (-20% ATK)",
      description: "Icy underground reservoir with frozen statues",
      enemy_types: ["Frost Revenant", "Ice Elemental"],
      hazards: ["Slippery ice", "Frostbite zones"],
    },
    {
      id: 10,
      name: "Obsidian Forges - Smoldering Anvils",
      region: "Obsidian Forges",
      level_range_min: 12,
      level_range_max: 14,
      effect: "fire",
      effect_description: "Take 5 damage per turn",
      description: "Blazing forges with molten obsidian flows",
      enemy_types: ["Forge Golem", "Ember Spirit"],
      hazards: ["Lava pools", "Falling debris"],
    },
    {
      id: 11,
      name: "Forge Depths - Molten Crucible",
      region: "Forge Depths",
      level_range_min: 13,
      level_range_max: 15,
      effect: "fire",
      effect_description: "Take 5 damage per turn",
      description: "Deep forge chambers with intense heat",
      enemy_types: ["Magma Wraith", "Iron Construct"],
      hazards: ["Molten spills", "Heat exhaustion"],
    },
    {
      id: 12,
      name: "Forge Depths - Ashen Foundry",
      region: "Forge Depths",
      level_range_min: 14,
      level_range_max: 16,
      effect: "dust",
      effect_description: "Your visibility is reduced (-10%)",
      description: "Abandoned foundry covered in ash and soot",
      enemy_types: ["Ash Hound", "Smelter Shade"],
      hazards: ["Ash clouds", "Broken machinery"],
    },
    {
      id: 13,
      name: "Cursed Highlands - Bloodstone Peaks",
      region: "Cursed Highlands",
      level_range_min: 15,
      level_range_max: 17,
      effect: "blood",
      effect_description: "Enemies have +5 HP",
      description: "Rugged peaks stained with crimson stone",
      enemy_types: ["Bloodstone Golem", "Veil Bat"],
      hazards: ["Rockslides", "Blood pools"],
    },
    {
      id: 14,
      name: "Crystal Spires - Veilspires",
      region: "Crystal Spires",
      level_range_min: 16,
      level_range_max: 18,
      effect: "veil",
      effect_description: "Your stamina drains faster (-10% stamina)",
      description: "Towering spires of shimmering crystals",
      enemy_types: ["Crystal Guardian", "Veil Sprite"],
      hazards: ["Crystal shards", "Mana surges"],
    },
    {
      id: 15,
      name: "Soulrift Nexus - Soulrift Nexus Core",
      region: "Soulrift Nexus",
      level_range_min: 17,
      level_range_max: 19,
      effect: "soul",
      effect_description: "Lose 5 HP per turn",
      description: "Ethereal rift pulsing with soul energy",
      enemy_types: ["Soul Wraith", "Ectoplasmic Horror"],
      hazards: ["Soul drain", "Rift instability"],
    },
    {
      id: 16,
      name: "Ethereal Bridges - Ethereal Pathways",
      region: "Ethereal Bridges",
      level_range_min: 18,
      level_range_max: 20,
      effect: "veil",
      effect_description: "Your stamina drains faster (-10% stamina)",
      description: "Floating bridges connecting ghostly realms",
      enemy_types: ["Bridge Specter", "Ethereal Stalker"],
      hazards: ["Bridge collapse", "Void winds"],
    },
    {
      id: 17,
      name: "Crystal Spires - Crystal Heart",
      region: "Crystal Spires",
      level_range_min: 19,
      level_range_max: 21,
      effect: "none",
      effect_description: "Neutral conditions",
      description: "Central chamber with a massive glowing crystal",
      enemy_types: ["Crystal Sentinel", "Prism Wraith"],
      hazards: ["Crystal fragments", "Light traps"],
    },
    {
      id: 18,
      name: "Guardian’s Gauntlet - Trial Grounds",
      region: "Guardian’s Gauntlet",
      level_range_min: 20,
      level_range_max: 22,
      effect: "guardian",
      effect_description: "Enemies have +10% DEF",
      description: "Ancient arena with guardian statues",
      enemy_types: ["Stone Guardian", "Rune Knight"],
      hazards: ["Rune traps", "Guardian statues"],
    },
    {
      id: 19,
      name: "Shattered Vestibule - King’s Chamber",
      region: "Shattered Vestibule",
      level_range_min: 21,
      level_range_max: 23,
      effect: "blood",
      effect_description: "Enemies have +5 HP",
      description: "Royal tomb with the Crypt King’s remains",
      enemy_types: ["Crypt King", "Royal Shade"],
      hazards: ["Cursed aura", "Collapsing ceiling"],
    },
    {
      id: 20,
      name: "Hall of Reflections - Mirror Maze",
      region: "Hall of Reflections",
      level_range_min: 22,
      level_range_max: 24,
      effect: "illusion",
      effect_description: "Randomly take 5-10 damage per turn",
      description: "Labyrinth of mirrors distorting reality",
      enemy_types: ["Mirror Doppelganger", "Reflection Wraith"],
      hazards: ["False paths", "Mirror shards"],
    },
    {
      id: 21,
      name: "Soulforge Altar - Ritual Site",
      region: "Soulforge Altar",
      level_range_min: 23,
      level_range_max: 25,
      effect: "soul",
      effect_description: "Lose 5 HP per turn",
      description: "Sacred site with soul-forged relics",
      enemy_types: ["Soulforger", "Ectoplasmic Priest"],
      hazards: ["Soul flames", "Ritual circles"],
    },
    {
      id: 22,
      name: "Hollow Depths - Bone Labyrinth",
      region: "Hollow Depths",
      level_range_min: 24,
      level_range_max: 26,
      effect: "darkness",
      effect_description: "Your accuracy is reduced (-15%)",
      description: "Twisting tunnels filled with bones",
      enemy_types: ["Bone Construct", "Skull Crawler"],
      hazards: ["Bone piles", "Narrow passages"],
    },
    {
      id: 23,
      name: "Ectoplasm Veins - Ectoplasmic Caverns",
      region: "Ectoplasm Veins",
      level_range_min: 25,
      level_range_max: 27,
      effect: "ectoplasm",
      effect_description: "Random status effects every 3 turns",
      description: "Caverns glowing with ectoplasmic veins",
      enemy_types: ["Ectoplasmic Slime", "Vein Guardian"],
      hazards: ["Ectoplasmic pools", "Slippery surfaces"],
    },
    {
      id: 24,
      name: "Forgotten Vaults - Sealed Chambers",
      region: "Forgotten Vaults",
      level_range_min: 26,
      level_range_max: 28,
      effect: "none",
      effect_description: "Neutral conditions",
      description: "Ancient vaults with locked treasure",
      enemy_types: ["Vault Golem", "Treasure Phantom"],
      hazards: ["Locked doors", "Pressure plates"],
    },
    {
      id: 25,
      name: "Forgotten Vaults - Hidden Treasury",
      region: "Forgotten Vaults",
      level_range_min: 27,
      level_range_max: 29,
      effect: "greed",
      effect_description: "Drop 10% more loot but take +5 damage",
      description: "Opulent chamber with guarded treasures",
      enemy_types: ["Gold Guardian", "Greed Spirit"],
      hazards: ["Trap chests", "Golden snares"],
    },
    {
      id: 26,
      name: "Fractured Plains - Shattered Expanse",
      region: "Fractured Plains",
      level_range_min: 28,
      level_range_max: 30,
      effect: "earth",
      effect_description: "Movement speed reduced (-15%)",
      description: "Rugged terrain with fractured ground",
      enemy_types: ["Earth Elemental", "Fracture Beast"],
      hazards: ["Ground fissures", "Rockfalls"],
    },
    {
      id: 27,
      name: "Echoing Abyss - Silent Depths",
      region: "Echoing Abyss",
      level_range_min: 29,
      level_range_max: 31,
      effect: "darkness",
      effect_description: "Your accuracy is reduced (-15%)",
      description: "Bottomless pit with echoing cries",
      enemy_types: ["Abyssal Echo", "Depth Lurker"],
      hazards: ["Falling rocks", "Echo traps"],
    },
    {
      id: 28,
      name: "Veil Nexus Core - Core Chamber",
      region: "Veil Nexus Core",
      level_range_min: 30,
      level_range_max: 32,
      effect: "veil",
      effect_description: "Your stamina drains faster (-10% stamina)",
      description: "Central hub of Veil energy",
      enemy_types: ["Veil Overlord", "Nexus Wraith"],
      hazards: ["Veil surges", "Energy barriers"],
    },
    {
      id: 29,
      name: "Eternal Spire - Guardian’s Ascent",
      region: "Eternal Spire",
      level_range_min: 31,
      level_range_max: 33,
      effect: "guardian",
      effect_description: "Enemies have +10% DEF",
      description: "Spiral ascent guarded by eternal sentinels",
      enemy_types: ["Eternal Sentinel", "Spire Guardian"],
      hazards: ["Guardian beams", "Steep drops"],
    },
    {
      id: 30,
      name: "Soulstorm Expanse - Tempest Plains",
      region: "Soulstorm Expanse",
      level_range_min: 32,
      level_range_max: 34,
      effect: "storm",
      effect_description: "Random 5-10 damage per turn",
      description: "Storm-ravaged plains with soul energy",
      enemy_types: ["Storm Wraith", "Tempest Elemental"],
      hazards: ["Lightning strikes", "Gale winds"],
    },
    {
      id: 31,
      name: "Oasis of the Lost - Sacred Spring",
      region: "Oasis of the Lost",
      level_range_min: 5,
      level_range_max: 7,
      effect: "heal",
      effect_description: "Regain 5 HP per turn",
      description: "Hidden oasis with healing waters",
      enemy_types: ["Water Sprite", "Lost Spirit"],
      hazards: ["Poisoned pools", "Mirage traps"],
    },
    {
      id: 32,
      name: "Oasis of the Lost - Ruined Temple",
      region: "Oasis of the Lost",
      level_range_min: 7,
      level_range_max: 9,
      effect: "none",
      effect_description: "Neutral conditions",
      description: "Dilapidated temple with ancient altars",
      enemy_types: ["Temple Guardian", "Sand Wraith"],
      hazards: ["Sand traps", "Collapsing pillars"],
    },
    {
      id: 33,
      name: "Cursed Highlands - Bloodstone Peaks",
      region: "Cursed Highlands",
      level_range_min: 10,
      level_range_max: 12,
      effect: "blood",
      effect_description: "Enemies have +5 HP",
      description: "Rugged peaks with crimson stone formations",
      enemy_types: ["Bloodstone Hound", "Veil Stalker"],
      hazards: ["Rockslides", "Blood mist"],
    },
    {
      id: 34,
      name: "Stormwracked Ridge - Thunder Peaks",
      region: "Stormwracked Ridge",
      level_range_min: 18,
      level_range_max: 20,
      effect: "storm",
      effect_description: "Random 5-10 damage per turn",
      description: "Jagged peaks struck by constant lightning",
      enemy_types: ["Thunder Elemental", "Storm Raven"],
      hazards: ["Lightning zones", "Wind gusts"],
    },
    {
      id: 35,
      name: "Veil-Touched Summit - Summit Peak",
      region: "Veil-Touched Summit",
      level_range_min: 20,
      level_range_max: 22,
      effect: "veil",
      effect_description: "Your stamina drains faster (-10% stamina)",
      description: "Highest point with Veil energy residue",
      enemy_types: ["Veil Watcher", "Summit Shade"],
      hazards: ["Veil winds", "Cracked ledges"],
    },
    {
      id: 36,
      name: "Dead Marshes - Fetid Mire",
      region: "Dead Marshes",
      level_range_min: 8,
      level_range_max: 10,
      effect: "poison",
      effect_description: "Take 5 damage per turn",
      description: "Swampy terrain with toxic fumes",
      enemy_types: ["Swamp Ghoul", "Poison Frog"],
      hazards: ["Toxic gas", "Quicksand"],
    },
    {
      id: 37,
      name: "Ghostlight Bog - Spectral Hollow",
      region: "Ghostlight Bog",
      level_range_min: 12,
      level_range_max: 14,
      effect: "ghost",
      effect_description: "Enemies have +10% evasion",
      description: "Swamp lit by ghostly lights",
      enemy_types: ["Ghostlight Wisp", "Bog Specter"],
      hazards: ["Ghostly fog", "Hidden pits"],
    },
    {
      id: 38,
      name: "Veilswamp - Mire Depths",
      region: "Veilswamp",
      level_range_min: 13,
      level_range_max: 15,
      effect: "poison",
      effect_description: "Take 5 damage per turn",
      description: "Deep swamp with Veil-tainted water",
      enemy_types: ["Veil Toad", "Swamp Lurker"],
      hazards: ["Poison vines", "Sinking mud"],
    },
    {
      id: 39,
      name: "Maw Outpost - Trader’s Market",
      region: "Maw Outpost",
      level_range_min: 5,
      level_range_max: 7,
      effect: "none",
      effect_description: "Neutral conditions",
      description: "Rustic outpost with traveling merchants",
      enemy_types: ["Bandit", "Deserter"],
      hazards: ["Thieves", "Overpriced goods"],
    },
    {
      id: 40,
      name: "Cursed Expanse Wastes - Ashen Hollow",
      region: "Cursed Expanse Wastes",
      level_range_min: 6,
      level_range_max: 10,
      effect: "dust",
      effect_description: "Your visibility is reduced (-10%)",
      description: "Small village of survivors in a crater, surrounded by ash dunes",
      enemy_types: ["Scavenger"],
      hazards: ["Ash storms", "Scavengers"],
    },
    {
      id: 41,
      name: "Cursed Highlands - Veilwatch Spire",
      region: "Cursed Highlands",
      level_range_min: 15,
      level_range_max: 20,
      effect: "veil",
      effect_description: "Your stamina drains faster (-10% stamina)",
      description: "Crumbling tower once used to monitor the Crypt’s curse",
      enemy_types: ["Veil Stalker"],
      hazards: ["Veil rifts", "Unstable floors"],
    },
  ];
  
  export const version = "1.0.0"; // For version checking